// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewLabel_container__RVRRH"};